import { SwiperSlide } from "swiper/react";

import { FaCheck } from "components/atoms/Icon/fa/FaCheck";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import PostItem from "components/molecules/PostItem";
import Banner from "components/organisms/Banner";
import Faqs from "components/organisms/Faqs";
import HowItWorks from "components/organisms/HowItWorks";
import PostSlider from "components/organisms/PostSlider";
import RequiredDocuments from "components/organisms/RequiredDocument";
import WhyChooseUs from "components/organisms/WhyChooseUs";

const Component = ({ posts, data }) => {
  return (
    <>
      <section>
        <Banner
          minHeightBanner="banner-min-h-569"
          title="Accounting, Auditing & Tax Filing"
          description="Capitalizing our digital solutions and seasoned CPA team to untangle your complexities of annual accounting tasks"
          bgColor="bg-bbc-gradient-service"
          breadcrumbs={data?.banner?.breadcrumbs}
          titleProps={{
            textColor: "banner-title-gradient-color",
          }}
          leftClassName="lg:col-6"
          rightClassName="lg:col-6 xl:pl-16"
          rightContent={
            <Img
              src="/assets/images/common/accounting-auditing-banner.png"
              width={622}
              height={400}
              alt="accounting and auditing services"
              className="h-full w-full"
              wrapper={{
                className:
                  "bbc-banner-image-country pb-10 lg:pb-0 banner-lg-max-w-500",
              }}
              priority={true}
            />
          }
        />
      </section>
      <section>
        <div className="container">
          <div>
            <Title
              text="Accounting & Auditing"
              className="mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:mb-10 lg:text-bbc-40px"
            />
            <p className="mb-6 leading-bbc-26 lg:mb-4">
              We can help you prepare and maintain accounting records to stay
              compliant with local regulations. Our local qualified accountants
              can also assist to prepare management reports with a review on a
              predetermined frequency to support your decision making process.
              Our specialized accounting system can work effectively to help you
              remove the needs for an in-house accounting department which is
              sometimes cost-ineffective to set up and maintain.
            </p>
            <p className="mb-6 leading-bbc-26 lg:mb-4">
              Our solutions include:
            </p>
            <div className="row justify-center">
              <ul className="col-12 leading-bbc-26 lg:col-10">
                <li className="relative">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Maintaining accounting records, including cash books,
                    general ledgers, fixed assets, accounts receivables, and
                    payable.
                  </span>
                </li>
                <li className="relative mt-3">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Preparing monthly, quarterly and yearly management accounts,
                    cash flow statements for management purposes.
                  </span>
                </li>
                <li className="relative mt-3">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Preparing annual financial statements.
                  </span>
                </li>
                <li className="relative mt-3">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Attending to the auditors during review of the company’s
                    financial records.
                  </span>
                </li>
                <li className="relative mt-3">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Administering the payroll process, including calculating and
                    crediting of the net remuneration to individual employee’s
                    bank account.
                  </span>
                </li>
                <li className="relative mt-3">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Setting up a mandatory provident fund scheme.
                  </span>
                </li>
                <li className="relative mt-3">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Arranging for retiring member benefits to be transferred
                    into their new employer or into a preserved account.
                  </span>
                </li>
                <li className="relative mt-3">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Completing the filing of employment with the local
                    authorities.
                  </span>
                </li>
                <li className="relative mt-3">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Application and renewal of employment visa.
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-6 lg:mt-10">
            <Title
              text="Tax Compliance Services"
              className="mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:mb-10 lg:text-bbc-40px"
            />
            <p className="mb-6 leading-bbc-26 lg:mb-4">
              The complex and constantly changing tax laws across many countries
              make the task of remaining compliant become more difficult for
              business owners, especially with startups and small companies.
              This leads to an obvious trend for outsourcing these
              functionalities to 3rd parties with specialized capacities to
              handle these compliance requirements.
            </p>
            <p className="mb-6 leading-bbc-26 lg:mb-4">
              BBCIncorp can assist you to manage tax obligations with tailored
              solutions as follows:
            </p>
            <div className="row justify-center">
              <ul className="col-12 leading-bbc-26 lg:col-10">
                <li className="relative">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Tax preparation including computing and filing appropriate
                    tax returns to local authorities.
                  </span>
                </li>
                <li className="relative mt-3">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Review tax assessments and notify you of any necessary tax
                    payments.
                  </span>
                </li>
                <li className="relative mt-3">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Assist in handling tax authority queries, tax field audits
                    and investigation.
                  </span>
                </li>
                <li className="relative mt-3">
                  <FaCheck
                    className="absolute top-1.5 left-0 text-bbc-brand-500"
                    size={12}
                  />
                  <span className="inline-block pl-7">
                    Other local tax compliance requirements.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <WhyChooseUs
        title="What makes us your good fit"
        sectionClassName="bg-bbc-gradient-2 py-10 lg:py-20"
        data={data?.dataWhyMakeUs}
      />
      <HowItWorks data={data?.dataHowItWork} className="mb-10 lg:mb-20">
        <Title className="text-center font-semibold lg:text-left">
          <span className="text-3xl text-bbc-brand-800 lg:block lg:text-bbc-40px">
            How{" "}
          </span>
          <span className="mt-4 text-3xl text-bbc-brand-800 lg:block lg:leading-[44px] lg:text-bbc-brand-700">
            It Works ?
          </span>
        </Title>
      </HowItWorks>
      <RequiredDocuments
        sectionClassName="mb-10 lg:mb-20 pt-14 pb-20"
        backgroundImage="/assets/images/common/required-documents.png"
        title="Accounting required documents"
        data={data?.dataRequiredDocuments}
      />
      <section>
        <div className="container">
          <div className="lg:col-10 lg:mx-auto">
            <Faqs data={data?.dataFaqs} />
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <PostSlider thetitle="Industry News & Insights">
            {posts.length > 0 &&
              posts.map((item, index) => (
                <SwiperSlide key={index}>
                  <PostItem post={item} />
                </SwiperSlide>
              ))}
          </PostSlider>
        </div>
      </section>
    </>
  );
};

export default Component;
